'use client'
import {
  FirstAvailablePlan_default
} from "./chunk-32AVF4GI.mjs";
import {
  useSubscription
} from "./chunk-NAUELPNF.mjs";

// src/components/checks/bookingLimit/Check.tsx
import { useMemo, useState } from "react";
import { BottomSheet, Button, Modal } from "@wbk/ui";
import { twMerge } from "tailwind-merge";
import { useDeviceDetect } from "@wbk/hooks";
import { useGetSubscriptionPlans } from "@wbk/api/hooks";
import { useAuth } from "@wbk/auth";
import { useRouter, useTranslation } from "@wbk/config";
import { useAnalytics } from "@wbk/analytics";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var TicketBookingLimitsTrigger = ({
  ticketBenefits,
  selectedTickets,
  onSelect,
  className,
  event
}) => {
  var _a, _b, _c, _d;
  const { trackEvent } = useAnalytics();
  const { slug } = useSubscription();
  const { locale } = useRouter();
  const { t } = useTranslation("subscription_common");
  const { isMobile } = useDeviceDetect();
  const [plan, setPlan] = useState();
  const { user } = useAuth();
  const { data, refetch } = useGetSubscriptionPlans(
    {
      lang: locale,
      subscriptionSlug: slug
    },
    { enabled: false }
  );
  const currentPlanName = ((_b = (_a = user == null ? void 0 : user.user_subscriptions) == null ? void 0 : _a[0]) == null ? void 0 : _b.plan.plan_group.name) || "";
  const plans = ticketBenefits.mustUpgradeToPlans.highest;
  const mustHavePlan = ticketBenefits.mustUpgradeToPlans.mustHavePlan;
  const hasLimit = Object.keys(ticketBenefits.mustUpgradeToPlans.allPlans).length > 0;
  const fistGroupId = hasLimit ? (_c = plans == null ? void 0 : plans[0]) == null ? void 0 : _c.subscription_plan_group_id : (_d = mustHavePlan == null ? void 0 : mustHavePlan.plan_group) == null ? void 0 : _d._id;
  const firstGroup = useMemo(() => {
    var _a2;
    return (_a2 = data == null ? void 0 : data.plan_groups) == null ? void 0 : _a2.find((group) => group._id === fistGroupId);
  }, [data == null ? void 0 : data.plan_groups, fistGroupId]);
  const booked = useMemo(() => {
    return selectedTickets.map((t2) => `${t2.qty} ${t2.title}`);
  }, [selectedTickets]);
  const trackUpgradeEvent = (confirm) => {
    var _a2, _b2;
    trackEvent({
      event: confirm ? "clicked_on_upgrade_continue_booking_limit" : "clicked_on_upgrade_booking_limit",
      data: {
        event_slug: event == null ? void 0 : event.slug,
        plan: firstGroup == null ? void 0 : firstGroup.name,
        billing_type: (_b2 = plan || ((_a2 = firstGroup == null ? void 0 : firstGroup.plans) == null ? void 0 : _a2[0])) == null ? void 0 : _b2.payment_terms
      }
    });
  };
  if (isMobile) {
    return /* @__PURE__ */ jsx(
      BottomSheet,
      {
        fullscreen: true,
        closeButton: true,
        className: "z-[99]",
        sectionClassName: "p-4",
        stickyHeader: () => /* @__PURE__ */ jsx("p", { className: "-mt-2 pb-4 text-center", children: t("subscription_common:upgrade") }),
        body: ({ close }) => /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            FirstAvailablePlan_default,
            {
              planGroupId: fistGroupId,
              header: "",
              title: mustHavePlan ? t("subscription_common:must_have_plan_title", {
                plan: mustHavePlan.plan_group.name
              }) : t("subscription_common:current_benefits_limit_booked", {
                booked: booked.join(" -- ")
              }).replace(/--/g, " & "),
              subtitle: mustHavePlan ? t("subscription_common:must_have_plan_subtitle") : t("subscription_common:current_benefits_limit_mini", {
                benefits: ticketBenefits.userCurrentBenefits.join(" -- "),
                plan: currentPlanName
              }).replace(/--/g, " & "),
              onConfirm: (planGroup, plan2) => {
                if (firstGroup) {
                  trackUpgradeEvent(true);
                  onSelect({ planGroup, plan: plan2 });
                }
              }
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              theme: "action",
              shape: "outlined",
              className: "mt-6 w-full",
              onClick: close,
              "data-testid": "subscription_cancel_upgrade_button",
              children: t("subscription_common:continue_with_less_tickets")
            }
          )
        ] }),
        render: ({ open }) => /* @__PURE__ */ jsx(
          Button,
          {
            type: "button",
            theme: "action",
            className,
            onClick: () => {
              trackUpgradeEvent();
              refetch();
              open();
            },
            "data-testids": "subscription_tickets_responsive_upgrade_button",
            children: /* @__PURE__ */ jsx("p", { className: "truncate font-semibold", children: t("subscription_common:next_upgrade") })
          }
        )
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Modal,
    {
      closeButton: true,
      size: "xl",
      className: "p-6",
      render: ({ open }) => /* @__PURE__ */ jsx(
        Button,
        {
          type: "button",
          theme: "action",
          className: twMerge("w-full px-8 font-semibold", className),
          "data-testids": "subscription_tickets_upgrade_button",
          onClick: () => {
            trackUpgradeEvent();
            open();
          },
          children: /* @__PURE__ */ jsx("p", { className: "truncate", children: t("subscription_common:next_upgrade") })
        }
      ),
      body: () => /* @__PURE__ */ jsx(
        FirstAvailablePlan_default,
        {
          className: "pb-20",
          planGroupId: fistGroupId,
          title: mustHavePlan ? t("subscription_common:must_have_plan_title", {
            plan: mustHavePlan.plan_group.name
          }) : t("subscription_common:current_benefits_limit_booked", {
            booked: booked.join(" -- ")
          }).replace(/--/g, " & "),
          subtitle: mustHavePlan ? t("subscription_common:must_have_plan_subtitle") : t("subscription_common:current_benefits_limit_mini", {
            benefits: ticketBenefits.userCurrentBenefits.join(" -- "),
            plan: currentPlanName
          }).replace(/--/g, " & "),
          onPlanChange: (plan2) => {
            setPlan(plan2);
          }
        }
      ),
      stickyFooter: ({ close }) => /* @__PURE__ */ jsxs("div", { className: "xs:flex-row xs:justify-end xs:gap-2 flex flex-col-reverse items-center gap-4 p-4", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            theme: "action",
            shape: "text",
            className: "xs:w-auto w-full",
            onClick: close,
            "data-testid": "subscription_upgrade_cancel_button",
            children: t("subscription_common:continue_with_less_tickets")
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            theme: "action",
            "data-hidden": !firstGroup,
            className: "xs:w-auto w-full px-12 data-[hidden=true]:hidden",
            onClick: () => {
              var _a2;
              if (firstGroup) {
                trackUpgradeEvent(true);
                onSelect({ planGroup: firstGroup, plan: plan || ((_a2 = firstGroup.plans) == null ? void 0 : _a2[0]) });
              }
            },
            "data-testid": "subscription_cancel_upgrade_button",
            children: t("subscription_common:upgrade_and_continue")
          }
        )
      ] })
    }
  );
};

export {
  TicketBookingLimitsTrigger
};
//# sourceMappingURL=chunk-636ZLOTK.mjs.map